import { render, staticRenderFns } from "./EditProfilCompanyPage.vue?vue&type=template&id=2f089e4e&"
import script from "./EditProfilCompanyPage.vue?vue&type=script&lang=js&"
export * from "./EditProfilCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f089e4e')) {
      api.createRecord('2f089e4e', component.options)
    } else {
      api.reload('2f089e4e', component.options)
    }
    module.hot.accept("./EditProfilCompanyPage.vue?vue&type=template&id=2f089e4e&", function () {
      api.rerender('2f089e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/EditProfilCompanyPage.vue"
export default component.exports